import React from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { DISPLAY_FONT } from '../trendTheme';

export function sectionTitle(title: string, helpText: string) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
      <Typography variant="h6" sx={{ fontFamily: DISPLAY_FONT, fontSize: '1.1rem' }}>{title}</Typography>
      <Tooltip title={helpText}><IconButton size="small" sx={{ color: 'text.secondary' }}><InfoOutlinedIcon fontSize="small" /></IconButton></Tooltip>
    </Stack>
  );
}
